import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import * as React from "react";
import DeleteButton from "../Buttons/DeleteButton";
import DeleteConfirmationDialog from "./DeleteConfirmationDialog";
import ErrorMsgDialog from "./ErrorMsgDialog";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";

interface Props {
  deleteMutation: any;
  deleteArgs: any;
  buttonLabel: string;
  confirmationDialogTitle: string;
  confirmationDialogMsg: string;
  errorDialogTitle: string;
  errorDialogMsg: string;
  useIcon?: boolean;
}

export default function DeletePanel({
  deleteMutation,
  deleteArgs,
  buttonLabel,
  confirmationDialogTitle,
  confirmationDialogMsg,
  errorDialogTitle,
  errorDialogMsg,
  useIcon = false,
}: Props): any {
  const [deleteFn, deleteParams] = deleteMutation();

  // 0 - initial state - dont show both dialogs
  // 1 - show confirmation dialog
  // 2 - show error dialog - currently not used.
  const [dialogState, setDialogState] = React.useState(0);

  if (deleteParams.isLoading) {
    return (
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }

  return (
    <div>
      {useIcon ? (
        <IconButton
          color="secondary"
          onClick={() => {
            setDialogState(1);
          }}
        >
          <DeleteIcon />
        </IconButton>
      ) : (
        <DeleteButton
          label={buttonLabel}
          onClickHandler={() => {
            setDialogState(1);
          }}
        />
      )}
      <DeleteConfirmationDialog
        open={dialogState === 1}
        agreeHandler={() => {
          setDialogState(0);
          deleteFn(deleteArgs);
        }}
        disagreeHandler={() => {
          setDialogState(0);
        }}
        title={confirmationDialogTitle}
        message={confirmationDialogMsg}
      />
      <ErrorMsgDialog
        open={deleteParams.isError}
        closeHandler={() => {
          setDialogState(0);
          deleteParams.reset();
        }}
        title={errorDialogTitle}
        message={errorDialogMsg}
      />
    </div>
  );
}
